export abstract class PdfViewerConfig {
  static style = {
    rqInternal: 'width: 100%; height: calc(100vh - 387px)',
    rqInternational: 'width: 100%; height: calc(100vh - 351px)',
    sm: 'width: 100%; height: calc(100vh - 335px)',
    md: 'width: 100%; height: calc(100vh - 298px)',
    lg: 'width: 100%; height: calc(100vh - 217px)',
  };
}
